import React from "react";
import { AppButton, IAppButtonProps } from "ui/Scripts/source/components/framework/Button/AppButton";

export const DangerButton = (props: IAppButtonProps) => {
    if (!props.onClick) return null;
    return (
        <AppButton
            variant="contained"
            color="error"
            {...props}
        >
            {props.children}
        </AppButton>
    );
};
